<template>
  <modal
    :classes="classes"
    width="400"
    height="400"
    :name="'modal-' + assignedName"
    :click-to-close="!strictClose"
    @closed="handleModalClose()"
  >
    <slot />
  </modal>
</template>

<script>
export default {
  props: {
    strictClose: {
      type: Boolean,
      default () {
        return false
      }
    },
    name: {
      type: String,
      default () {
        return null
      }
    },
    show: {
      type: Boolean,
      default () {
        return false
      }
    },
    classes: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      assignedName: ''
    }
  },
  watch: {
    show: {
      handler (value) {
        if (value === false) {
          this.hideModal()
        }
        this.showModal()
      }
    }
  },
  mounted () {
    this.assignedName = this.name || this.getRandomInt()
  },
  methods: {
    showModal () {
      this.$modal.show('modal-' + this.assignedName)
    },
    hideModal () {
      this.$modal.hide('modal-' + this.assignedName)
    },
    handleModalClose () {
      this.$emit('update:show', false)
    },
    getRandomInt () {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5
    }
  }
}
</script>

<style scoped></style>
